<template>
  <v-alert
    :style="{
      ...(maxWidth ? { 'max-width': `${maxWidth}px` } : {}),
    }"
    color="error"
    border="top"
    colored-border
    type="error"
    elevation="2"
  >
    <div>
      <Header4>{{ title }}</Header4>
      <TextBody>
        {{ message }}
      </TextBody>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import TextBody from "components/UI/TextBody.vue"
import Header2 from "app/ui-primitives/header/Header2.vue"
import Header4 from "app/ui-primitives/header/Header4.vue"

export default defineComponent({
  name: "ErrorAlert",
  components: { Header4, Header2, TextBody },
  props: {
    title: {
      type: String,
      default: "Fehler",
    },
    message: {
      type: String,
      default: "Es ist ein Fehler aufgetreten. Versuche es später erneut.",
    },
    maxWidth: {
      type: Number,
      default: null,
    },
  },
})
</script>
